import { DatadogRUM } from '@user-portal/datadog-rum';
import { createFirehoseEventWriter, ExperimentationClientConfig } from '@user-portal/experimentation';

import { EPPO_EVENT_SOURCE, PROJECT } from 'constants/eppo';

const eventWriter = createFirehoseEventWriter({
    identityPoolId: import.meta.env.FIREHOSE_AWS_ID,
    streamName: import.meta.env.FIREHOSE_STREAM_NAME,
    eventSourceName: EPPO_EVENT_SOURCE,
});

export const experimentationConfig: ExperimentationClientConfig = {
    apiKey: import.meta.env.EPPO_SDK_KEY,
    stage: import.meta.env.ENV,
    projectName: PROJECT,
    projectNamespace: import.meta.env.PROJECT_NAME,
    eventWriter,
    metricWriter: DatadogRUM.getExperimentationMetricWriter(),
};
